import React from "react";
import { Outlet } from "react-router-dom";
import Header from "./Team/Common/Header";
import Sidebar from "./Team/Common/Sidebar";
import Loader from "./Loader";
import { ToastContainer } from "react-toastify";
import "./../Public/css/bootstrap.min.css";
import "./../Public/css/tabler-icons.css";
import "./../Public/css/fontawesome.min.css";
import "./../Public/css/all.min.css";
import "./../Public/css/style.css";
import "./../Public/css/custom_style.css";

const Layout = ({children}) =>
{
    return(
    <div className="main-wrapper crm-dashboard">

        <Loader />

        <Header />

        <Sidebar />

        <div className="page-wrapper">

            {children}
        </div>

        <ToastContainer />
    </div>


    )
}

export default Layout;
